import { renderContentFromMetadata } from '@jutro/uiconfig';
import _ from 'lodash';
import React, {
    useCallback, useState, useMemo, useContext, useEffect
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { useAuthentication } from 'gw-digital-auth-react';
import { Icon, Loader, DropdownSelectField } from '@jutro/components';
import { useDependencies } from 'gw-portals-dependency-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import metadata from './MyPreferences.metadata.json5';
import messages from './MyPreferences.messages';
import styles from './MyPreferences.module.scss';
import UsersProfileDetailsService
    from '../../customer/capabilities/nexus-capability-profileinfo/services/UsersProfileDetailsService';
import { getFontIcon, getProductName } from '../../customer/utils/lobIconUtil';
// import { messages as commonMessages } from 'gw-platform-translations';

const SAVE_MESSAGES = {
    saveSuccess: 'saveSuccess',
    saveError: 'saveError',
    saveAuthorityError: 'saveAuthorityError',
    saveDocPreferenceSuccess: 'saveDocPreferenceSuccess',
    saveDocPreferenceError: 'saveDocPreferenceError'
};

function MyPreferences() {
    const [formData, updateFormData] = useState({});
    const [accountPolicyData, updateAccountPolicyData] = useState([]);
    // const [policyDocConsentValue, updatePolicyDocConsentValue] = useState(false);
    const [status, updateStatus] = useState(null);
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const [isLoading, setIsLoading] = useState(false);
    const { PolicyService } = useDependencies('PolicyService');
    const viewModelService = useContext(ViewModelServiceContext);

    const createPolicySummaryVM = (data) => {
        return viewModelService.create(
            data,
            'pc',
            'edge.capabilities.policy.dto.PolicyBasicDetailsDTO'
        );
    };

    const writeValue = useCallback(
        (value, path) => {
            const nextFormData = _.cloneDeep(formData);
            _.set(nextFormData, path, value);
            updateFormData(nextFormData);
            updateStatus('');
        },
        [formData]
    );

    const writeDocPreferenceValue = useCallback(
        (value, path, index) => {
            accountPolicyData[index].policyDocDispatchMode.value = value;
            updateAccountPolicyData(_.clone(accountPolicyData));
        },
        [accountPolicyData]
    );

    const getDocumentPreference = useCallback((item, index, { path: property }) => {
        return (
            <DropdownSelectField
                id={`property${index}`}
                alwaysShowPlaceholder={false}
                availableValues={accountPolicyData[index].policyDocDispatchMode.aspects.availableValues.map((typeCode) => {
                    return {
                        code: typeCode.code,
                        name: translator({
                            id: typeCode.name,
                            defaultMessage: typeCode.name
                        })
                    };
                })}
                path={accountPolicyData[index].policyDocDispatchMode}
                onValueChange={(value, path) => writeDocPreferenceValue(value, path, index)}
                value={(accountPolicyData[index].policyDocDispatchMode.value || 'post')}
                className={styles.involvmentInjuredDropDown}
            />
        );
    }, [accountPolicyData]);

    const getDataCell = (item, index, { path: property }) => {
        return (
            <div>
                {item[property].value}
            </div>
        );
    };

    const getProductIcon = useCallback((item) => {
        const icon = getFontIcon(item.productCode.value);
        return <Icon role="img" className={styles.policyTypeIcon} icon={icon} title={getProductName(item.productCode)} key={item.productCode} />;
    }, []);

    useEffect(() => {
        setIsLoading(true);
        UsersProfileDetailsService.getAccountAGMdetails(authHeader)
            .then((response) => {
                if (response !== null && response.accountNumber !== undefined) {
                    writeValue(response.agmreport_EY, 'aGMReportEY');
                    writeValue(response.dispatchMode_EY, 'dispatchModeEY');
                    updateFormData({
                        aGMReportEY: response.agmreport_EY,
                        dispatchModeEY: response.dispatchMode_EY
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                // setIsLoading(false);
            });
        PolicyService.getUserPolicySummaries(authHeader)
            .then((responseData) => {
                if (responseData && responseData.length > 0) {
                    const hoAndAutoPolicies = responseData.filter((data) => data.periods && data.periods.length > 0
                        && (data.producerContact && !data.producerContact.isBroker)
                        && (data.periods[0].productCode === 'HOPHomeowners' || data.periods[0].productCode === 'BusinessAuto'))
                        .map((policySummary) => {
                            return createPolicySummaryVM({
                                policyNumber: policySummary.policyNumber,
                                productCode: policySummary.periods[0].productCode,
                                accountNumber: policySummary.accountNumber,
                                policyDocDispatchMode: policySummary.policyDocDispatchMode
                            });
                        });
                    updateAccountPolicyData(hoAndAutoPolicies);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setIsLoading(false);
            });
    }, [UsersProfileDetailsService, PolicyService, authHeader]);

    /* const updatePolicyDocEmailConsentValue = (value) => {
        updatePolicyDocConsentValue(value);
    }; */

   /* const isEmailOptionSelected = useMemo(() => {
        return accountPolicyData.filter((data) => data.policyDocDispatchMode.value && (data.policyDocDispatchMode.value.code === 'email')).length > 0;
    }, [accountPolicyData]); */

    /* const applyDocPreferenceChanges = useCallback(() => {
        if (isEmailOptionSelected && !policyDocConsentValue) {
            return ModalNextProvider.showAlert({
                title: commonMessages.errorUploadTitle,
                message: messages.policyConsentSelectWarning,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
        }
        setIsLoading(true);
        const policiesValues = accountPolicyData.map((data) => data.value);
        PolicyService.updatePolicyDocumentPreference(policiesValues, authHeader)
            .then((res) => {
                updateStatus(SAVE_MESSAGES.saveDocPreferenceSuccess);
            })
            .catch((error) => {
                updateStatus(SAVE_MESSAGES.saveDocPreferenceError);
            }).finally(() => {
            setIsLoading(false);
        });
    }, [policyDocConsentValue, accountPolicyData, authHeader, PolicyService, isEmailOptionSelected, ModalNextProvider]); */


    const saveChanges = useCallback(() => {
        setIsLoading(true);
        const aGMReportEY = _.get(formData, 'aGMReportEY');
        let dispatchModeEY = null;

        if (aGMReportEY) {
            dispatchModeEY = _.get(formData, 'dispatchModeEY');
        }
        UsersProfileDetailsService.updateAccountAGMDetails(aGMReportEY, dispatchModeEY, authHeader)
            .then(() => {
                updateStatus(SAVE_MESSAGES.saveSuccess);
            })
            .catch((error) => {
                if (error.baseError !== undefined && error.baseError.includes('authority')) {
                    updateStatus(SAVE_MESSAGES.saveAuthorityError);
                } else {
                    updateStatus(SAVE_MESSAGES.saveError);
                }
            }).finally(() => {
                setIsLoading(false);
            });
    }, [UsersProfileDetailsService, authHeader, formData]);

    const readValue = useCallback((id, path) => _.get(formData, path), [formData]);

    const overrideProps = useMemo(
        () => ({
            '@field': {
                onValueChange: writeValue
            },
            modeOfReciveMaterials: {
                visible: _.get(formData, 'aGMReportEY') === true
            },
            myPreferenceError: {
                visible: status === SAVE_MESSAGES.saveError || status === SAVE_MESSAGES.saveAuthorityError
            },
            errorMsg: {
                message: translator(messages[status])
            },
            myPreferenceSuccess: {
                visible: status === SAVE_MESSAGES.saveSuccess
            },
            successMsg: {
                message: translator(messages[status])
            },
            policyDocTableContainer: {
                data: accountPolicyData
            },
            policyDocPreferenceTable: {
                data: accountPolicyData
            },
            /* myDocPreferenceError: {
                visible: status === SAVE_MESSAGES.saveDocPreferenceError
            },
            errorDocPreferenceMsg: {
                message: translator(messages[status])
            },
            myDocPreferenceSuccess: {
                visible: status === SAVE_MESSAGES.saveDocPreferenceSuccess
            },
            docPreferenceSuccessMsg: {
                message: translator(messages[status])
            },
            policyDocEmailConsentField: {
                visible: isEmailOptionSelected,
                value: policyDocConsentValue
            } */
        }),
        [writeValue, formData, status, accountPolicyData]
    );
    const resolvers = useMemo(
        () => ({
            resolveValue: readValue,
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                applyChanges: saveChanges,
                getDataCell: getDataCell,
                getProductIcon: getProductIcon,
                getDocumentPreference: getDocumentPreference,
                // applyDocPreferenceChanges,
                // updatePolicyDocEmailConsentValue
            },
        }),
        [readValue, accountPolicyData]
    );
    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

export default MyPreferences;
